import React from 'react';
import { useSelector } from 'react-redux';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import PropTypes from 'prop-types';
import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';
import BaseTemperatureChannel from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BaseTemperatureChannel/BaseTemperatureChannel';
import { selectSessionInformation } from '../../../redux/slices/sessionSlice';

function ChannelValueWithUnitsFromChannelKeyObject({ channelKey, value, customUnits }) {
  const channel = ChannelService.getChannelGroupChannel(
    channelKey.channelGroupType,
    channelKey.channelIndex,
    channelKey.channelType,
  );
  const { temperatureScale, airSpeedScale } = useSelector(selectSessionInformation);
  const scale = channel instanceof BaseTemperatureChannel
    ? temperatureScale
    : airSpeedScale;
  return (
    <>
      {channel.getDisplayValue(value, { scale, airSpeedScale })}
      {' '}
      {channel.getUnits({ scale, customUnits, airSpeedScale })}
    </>
  );
}

ChannelValueWithUnitsFromChannelKeyObject.propTypes = {
  channelKey: PropTypes.shape(ChannelKey.class).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // eslint-disable-next-line react/require-default-props
  customUnits: PropTypes.string,
};
export default ChannelValueWithUnitsFromChannelKeyObject;
